import { EMPTY_FIELD } from 'constants/emptyField';

import { formatInTimeZone } from 'date-fns-tz';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';

import { parseDateInput } from './parseDateInput';

type OptionsType = {
  timezone?: string | null;
  format: string;
  placeholder?: string;
};

/**
 * Форматирует входное значение даты в строку с учётом таймзоны.
 * Если дату невозможно распарсить, возвращается placeholder.
 *
 * @example
 * formatInputInTz('2024-01-01T10:00:00Z', {
 *   format: 'dd.MM.yyyy HH:mm',
 *   timezone: 'Europe/Moscow'
 * })
 * // → "01.01.2024 13:00"
 */
export function formatInputInTz(
  input: unknown,
  { timezone = DEFAULT_TIMEZONE, format, placeholder = EMPTY_FIELD }: OptionsType,
): string {
  const date = parseDateInput(input);

  if (!date || !timezone) {
    return placeholder;
  }

  return formatInTimeZone(date, timezone, format);
}
